// Button traits: types 1-4 with their hover, inactive and badge states.
import {
  addButtonHoverTrait,
  addButtonTrait,
  addStyle,
  addTextTrait,
  cssSize,
  type CssMap,
} from "@/modules/styleCss";
import type { StyleTraits } from "@/types/experience";

export function loadButtonTraits(
  target: string,
  css: CssMap,
  traits: StyleTraits,
) {
  if (traits.buttonType1) {
    addTextTrait(target, css, ".button.type-1.text span", traits.buttonType1);
    addStyle(
      target,
      css,
      ".button.type-1.text",
      "font-size",
      traits.buttonType1.fontSize,
    );
    addButtonTrait(target, css, ".button.type-1", traits.buttonType1);
    addStyle(
      target,
      css,
      ".button.type-1",
      "height",
      cssSize(traits.buttonType1.height),
    );
    addStyle(
      target,
      css,
      ".button.type-1.square",
      "width",
      cssSize(traits.buttonType1.height),
    );
  }

  if (traits.buttonHoverType1) {
    addTextTrait(
      target,
      css,
      ".button.hover.type-1.text:hover span",
      traits.buttonHoverType1,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.hover.type-1",
      traits.buttonHoverType1,
    );
  }

  if (traits.buttonInactiveType1) {
    addStyle(target, css, ".button.type-1.inactive", "opacity", "1.0");
    addTextTrait(
      target,
      css,
      ".button.type-1.text.inactive span",
      traits.buttonInactiveType1,
    );
    addButtonTrait(
      target,
      css,
      ".button.type-1.inactive",
      traits.buttonInactiveType1,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.type-1.inactive",
      traits.buttonInactiveType1,
    );
  }

  if (traits.buttonType2) {
    addTextTrait(target, css, ".button.type-2.text span", traits.buttonType2);
    addStyle(
      target,
      css,
      ".button.type-2.text",
      "font-size",
      traits.buttonType2.fontSize,
    );
    addButtonTrait(target, css, ".button.type-2", traits.buttonType2);

    if (traits.buttonType2.height) {
      addStyle(
        target,
        css,
        ".button.type-2",
        "height",
        cssSize(traits.buttonType2.height),
      );
      addStyle(
        target,
        css,
        ".button.type-2.square",
        "width",
        cssSize(traits.buttonType2.height),
      );
      addStyle(
        target,
        css,
        ".favorite-delete.button",
        "height",
        cssSize(traits.buttonType2.height),
      );
      addStyle(
        target,
        css,
        ".favorite-delete.button",
        "width",
        cssSize(traits.buttonType2.height),
      );
      addStyle(
        target,
        css,
        ".favorite-cta-btn",
        "margin-left",
        cssSize(parseInt(traits.buttonType2.height as string) + 10),
      );
      addStyle(
        target,
        css,
        ".favorite-cta-btn",
        "margin-right",
        cssSize(parseInt(traits.buttonType2.height as string) + 10),
      );
    }
  } else if (traits.buttonType1) {
    addTextTrait(target, css, ".button.type-2.text span", traits.buttonType1);
    addStyle(
      target,
      css,
      ".button.type-2.text",
      "font-size",
      traits.buttonType1.fontSize,
    );
    addButtonTrait(target, css, ".button.type-2", traits.buttonType1);

    if (traits.buttonType1.height) {
      addStyle(
        target,
        css,
        ".button.type-2",
        "height",
        cssSize(traits.buttonType1.height),
      );
      addStyle(
        target,
        css,
        ".button.type-2.square",
        "width",
        cssSize(traits.buttonType1.height),
      );
      addStyle(
        target,
        css,
        ".favorite-delete.button",
        "height",
        cssSize(traits.buttonType1.height),
      );
      addStyle(
        target,
        css,
        ".favorite-delete.button",
        "width",
        cssSize(traits.buttonType1.height),
      );
      addStyle(
        target,
        css,
        ".favorite-cta-btn",
        "margin-left",
        cssSize(parseInt(traits.buttonType1.height as string) + 10),
      );
      addStyle(
        target,
        css,
        ".favorite-cta-btn",
        "margin-right",
        cssSize(parseInt(traits.buttonType1.height as string) + 10),
      );
    }
  }

  if (traits.buttonHoverType2) {
    addTextTrait(
      target,
      css,
      ".button.hover.type-2.text:hover span",
      traits.buttonHoverType2,
    );
    addStyle(
      target,
      css,
      ".button.hover.type-2.text:hover",
      "font-size",
      traits.buttonHoverType2.fontSize,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.hover.type-2",
      traits.buttonHoverType2,
    );
  } else if (traits.buttonHoverType1) {
    addTextTrait(
      target,
      css,
      ".button.hover.type-2.text:hover span",
      traits.buttonHoverType1,
    );
    addStyle(
      target,
      css,
      ".button.hover.type-2.text:hover",
      "font-size",
      traits.buttonHoverType1.fontSize,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.hover.type-2",
      traits.buttonHoverType1,
    );
  }

  if (traits.buttonInactiveType2) {
    addStyle(target, css, ".button.type-2.inactive", "opacity", "1.0");
    addTextTrait(
      target,
      css,
      ".button.type-2.text.inactive span",
      traits.buttonInactiveType2,
    );
    addButtonTrait(
      target,
      css,
      ".button.type-2.inactive",
      traits.buttonInactiveType2,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.type-2.inactive",
      traits.buttonInactiveType2,
    );

    addButtonTrait(
      target,
      css,
      ".button.type-2.inactive .badge",
      traits.buttonInactiveType2,
    );
  } else if (traits.buttonInactiveType1) {
    addStyle(target, css, ".button.type-2.inactive", "opacity", "1.0");
    addTextTrait(
      target,
      css,
      ".button.type-2.text.inactive span",
      traits.buttonInactiveType1,
    );
    addButtonTrait(
      target,
      css,
      ".button.type-2.inactive",
      traits.buttonInactiveType1,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.type-2.inactive",
      traits.buttonInactiveType1,
    );

    addButtonTrait(
      target,
      css,
      ".button.type-2.inactive .badge",
      traits.buttonInactiveType1,
    );
  }

  if (traits.buttonBadgeType2) {
    addTextTrait(
      target,
      css,
      ".button.type-2 .badge span",
      traits.buttonBadgeType2,
    );
    addStyle(
      target,
      css,
      ".button.type-2 .badge",
      "font-size",
      traits.buttonBadgeType2.fontSize,
    );
    addButtonTrait(
      target,
      css,
      ".button.type-2 .badge",
      traits.buttonBadgeType2,
    );
  } else if (traits.buttonType1) {
    addButtonTrait(target, css, ".button.type-2 .badge", traits.buttonType1, {
      borderRadius: false,
    });
  } else if (traits.buttonType2) {
    addButtonTrait(target, css, ".button.type-2 .badge", traits.buttonType2, {
      borderRadius: false,
    });
  }

  if (traits.buttonType3) {
    addTextTrait(target, css, ".button.type-3.text span", traits.buttonType3);
    addStyle(
      target,
      css,
      ".button.type-3.text",
      "font-size",
      traits.buttonType3.fontSize,
    );
    addButtonTrait(target, css, ".button.type-3", traits.buttonType3);
    addStyle(
      target,
      css,
      ".button.type-3",
      "height",
      cssSize(traits.buttonType3.height),
    );
    addStyle(
      target,
      css,
      ".button.type-3.square",
      "width",
      cssSize(traits.buttonType3.height),
    );
  }

  if (traits.buttonHoverType3) {
    addTextTrait(
      target,
      css,
      ".button.hover.type-3.text:hover span",
      traits.buttonHoverType3,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.hover.type-3",
      traits.buttonHoverType3,
    );
  }

  if (traits.buttonInactiveType3) {
    addStyle(target, css, ".button.type-3.inactive", "opacity", "1.0");
    addTextTrait(
      target,
      css,
      ".button.type-3.text.inactive span",
      traits.buttonInactiveType3,
    );
    addButtonTrait(
      target,
      css,
      ".button.type-3.inactive",
      traits.buttonInactiveType3,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.type-3.inactive",
      traits.buttonInactiveType3,
    );
  }

  if (traits.buttonType4) {
    addTextTrait(
      target,
      css,
      ".button.type-4.icon-label span",
      traits.buttonType4,
    );
    addStyle(
      target,
      css,
      ".button.type-4.icon-label",
      "font-size",
      traits.buttonType4.fontSize,
    );
    addButtonTrait(target, css, ".button.type-4", traits.buttonType4);
    addStyle(
      target,
      css,
      ".button.type-4",
      "height",
      cssSize(traits.buttonType4.height),
    );
    addStyle(
      target,
      css,
      ".button.type-4.square",
      "width",
      cssSize(traits.buttonType4.height),
    );
  }

  if (traits.buttonHoverType4) {
    addTextTrait(
      target,
      css,
      ".button.hover.type-4:hover span",
      traits.buttonHoverType4,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.hover.type-4",
      traits.buttonHoverType4,
    );
  }

  if (traits.buttonInactiveType4) {
    addStyle(target, css, ".button.type-4.inactive", "opacity", "1.0");
    addTextTrait(
      target,
      css,
      ".button.type-4.icon-label.inactive span",
      traits.buttonInactiveType4,
    );
    addButtonTrait(
      target,
      css,
      ".button.type-4.inactive",
      traits.buttonInactiveType4,
    );
    addButtonHoverTrait(
      target,
      css,
      ".button.type-4.inactive",
      traits.buttonInactiveType4,
    );
  }
}
